import { toast } from "react-toastify";
import { postApiCall } from "../Handlers/HttpHandler"

export const getAllCurrencies = async(token) => {
    let response = await postApiCall("currency/get", {token: token});

    if (response.StatusCode === 0) {
        return response.data;
    } else {
        toast.error(response.StatusMessage)
        return null;
    }
}   